const TestimonialsSection = () => {
  const testimonialsRow1 = [{
    quote: "thinker.os transformed our marketing workflow. Campaigns that used to take days now launch in hours with better results.",
    title: "Marketing Director",
    company: "Leading fashion retailer",
    date: "Dec 2025"
  }, {
    quote: "The AI-powered product optimization increased our conversion rate by 35% in the first month alone.",
    title: "Head of Ecommerce",
    company: "Global beauty brand",
    date: "Nov 2025"
  }, {
    quote: "With thinker.os, even team members without technical skills can leverage AI to drive growth. It's democratized our capabilities.",
    title: "CEO",
    company: "Mid-size consumer goods company",
    date: "Jan 2026"
  }, {
    quote: "The ROI was immediate. We're generating better ad creatives, optimizing inventory, and scaling faster than ever.",
    title: "Chief Digital Officer",
    company: "Multi-brand retail group",
    date: "Oct 2025"
  }, {
    quote: "thinker.os gave us the operational efficiency of a company 10x our size. It's like having an entire team of experts.",
    title: "Founder",
    company: "DTC wellness brand",
    date: "Dec 2025"
  }, {
    quote: "We're leveraging the AI agents to automate everything from product descriptions to profit analysis. The time savings are incredible.",
    title: "Operations Manager",
    company: "Electronics ecommerce store",
    date: "Nov 2025"
  }];
  const testimonialsRow2 = [{
    quote: "Our team velocity increased 3x after implementing thinker.os. Tasks that took hours now take minutes.",
    title: "Product Manager",
    company: "Tech-enabled marketplace",
    date: "Jan 2026"
  }, {
    quote: "The AI understands our brand voice perfectly. It's like having a seasoned copywriter available 24/7.",
    title: "Creative Director",
    company: "Premium lifestyle brand",
    date: "Dec 2025"
  }, {
    quote: "thinker.os helped us scale from $1M to $10M ARR without proportionally increasing our team size.",
    title: "Co-Founder",
    company: "Fast-growing DTC startup",
    date: "Oct 2025"
  }, {
    quote: "The insights we get from thinker.os have completely transformed our decision-making process.",
    title: "VP of Strategy",
    company: "International retail chain",
    date: "Nov 2025"
  }, {
    quote: "We cut our customer acquisition costs by 40% while improving ad performance. The platform pays for itself many times over.",
    title: "Growth Lead",
    company: "Health & wellness brand",
    date: "Jan 2026"
  }, {
    quote: "thinker.os is not just a tool, it's a competitive advantage. We're moving faster than ever before.",
    title: "Chief Technology Officer",
    company: "Omnichannel retailer",
    date: "Dec 2025"
  }];
  return <section className="w-full py-16 md:py-24 bg-gray-50/50 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 mb-12 md:mb-16">
        <h2 className="text-3xl font-serif font-normal text-center text-foreground md:text-5xl">Every team gets smarter with thinker.</h2>
      </div>

      <div className="relative space-y-6">
        {/* First row - scrolling left */}
        <div className="flex animate-scroll-left">
          {testimonialsRow1.map((testimonial, index) => <div key={`row1-first-${index}`} className="flex-shrink-0 w-[280px] md:w-[400px] mx-2 md:mx-4">
              <div className="bg-white border border-gray-200 rounded-xl md:rounded-2xl p-4 md:p-8 h-full flex flex-col justify-between hover:shadow-md transition-all">
                <p className="text-sm md:text-base text-foreground mb-4 md:mb-8 leading-relaxed">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-end justify-between">
                  <div>
                    <p className="text-xs md:text-sm font-medium text-foreground mb-1">
                      {testimonial.title}
                    </p>
                    <p className="text-xs md:text-sm text-gray-600">
                      {testimonial.company}
                    </p>
                  </div>
                  <p className="text-xs text-gray-500">
                    {testimonial.date}
                  </p>
                </div>
              </div>
            </div>)}
          {testimonialsRow1.map((testimonial, index) => <div key={`row1-second-${index}`} className="flex-shrink-0 w-[280px] md:w-[400px] mx-2 md:mx-4">
              <div className="bg-white border border-gray-200 rounded-xl md:rounded-2xl p-4 md:p-8 h-full flex flex-col justify-between hover:shadow-md transition-all">
                <p className="text-sm md:text-base text-foreground mb-4 md:mb-8 leading-relaxed">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-end justify-between">
                  <div>
                    <p className="text-xs md:text-sm font-medium text-foreground mb-1">
                      {testimonial.title}
                    </p>
                    <p className="text-xs md:text-sm text-gray-600">
                      {testimonial.company}
                    </p>
                  </div>
                  <p className="text-xs text-gray-500">
                    {testimonial.date}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {/* Second row - scrolling right */}
        <div className="flex animate-scroll-right">
          {testimonialsRow2.map((testimonial, index) => <div key={`row2-first-${index}`} className="flex-shrink-0 w-[280px] md:w-[400px] mx-2 md:mx-4">
              <div className="bg-white border border-gray-200 rounded-xl md:rounded-2xl p-4 md:p-8 h-full flex flex-col justify-between hover:shadow-md transition-all">
                <p className="text-sm md:text-base text-foreground mb-4 md:mb-8 leading-relaxed">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-end justify-between">
                  <div>
                    <p className="text-xs md:text-sm font-medium text-foreground mb-1">
                      {testimonial.title}
                    </p>
                    <p className="text-xs md:text-sm text-gray-600">
                      {testimonial.company}
                    </p>
                  </div>
                  <p className="text-xs text-gray-500">
                    {testimonial.date}
                  </p>
                </div>
              </div>
            </div>)}
          {testimonialsRow2.map((testimonial, index) => <div key={`row2-second-${index}`} className="flex-shrink-0 w-[280px] md:w-[400px] mx-2 md:mx-4">
              <div className="bg-white border border-gray-200 rounded-xl md:rounded-2xl p-4 md:p-8 h-full flex flex-col justify-between hover:shadow-md transition-all">
                <p className="text-sm md:text-base text-foreground mb-4 md:mb-8 leading-relaxed">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-end justify-between">
                  <div>
                    <p className="text-xs md:text-sm font-medium text-foreground mb-1">
                      {testimonial.title}
                    </p>
                    <p className="text-xs md:text-sm text-gray-600">
                      {testimonial.company}
                    </p>
                  </div>
                  <p className="text-xs text-gray-500">
                    {testimonial.date}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default TestimonialsSection;
